export default function minDate(date: Date){
    const offset = date.getTimezoneOffset()
    const timeZoneDate = new Date(date.getTime() - (offset * 60 * 1000))
    return timeZoneDate.toISOString().split("T")[0]
}
